<template>
    <div class="Info">
        <!-- <div class="InfoTit">个人信息</div> -->
        <div class="StepJiBen">
            <div class="StepJiBenItem">
                <div class="StepJiBenItemTit"><span class="Tit">姓名</span></div>
                <div class="StepJiBenItemVal">
                    <el-input placeholder="请输入" v-model="SetData.nickname"></el-input>
                </div>
            </div>
            <!-- <div class="StepJiBenItem">
                <div class="StepJiBenItemTit"><span class="Tit">性别</span></div>
                <div class="StepJiBenItemVal">
                    <el-radio-group v-model="SetData.gender">
                        <el-radio :label="1">男</el-radio>
                        <el-radio :label="2">女</el-radio>
                    </el-radio-group>
                </div>
            </div> -->
            <div class="StepJiBenItem">
                <div class="StepJiBenItemTit"><span class="Tit">手机号</span></div>
                <div class="StepJiBenItemVal">
                    <el-input placeholder="请输入" v-model="SetData.phonenumber" disabled></el-input>
                </div>
            </div>
            <div class="StepJiBenItem">
                <div class="StepJiBenItemTit"><span class="Tit">所属单位</span></div>
                <div class="StepJiBenItemVal">
                    <el-input placeholder="请输入" v-model="SetData.hospitalName" disabled></el-input>
                </div>
            </div>
            <!-- <div class="StepJiBenItem">
                <div class="StepJiBenItemTit"><span class="Tit">邮箱</span></div>
                <div class="StepJiBenItemVal">
                    <el-input placeholder="请输入" v-model="SetData.email"></el-input>
                </div>
            </div> -->
        </div>
        <div class="OrderBtns">
            <!-- <div class="OrderBtn BgBlue" @click="SetInfo">修改</div> -->
            <div class="OrderBtn BgBlue" @click="showChangePasswordDialog">修改密码</div>
        </div>

        <!-- 修改密码对话框 -->
        <el-dialog title="修改密码" :visible.sync="passwordDialogVisible" :width="isMobile ? '90%' : '30%'" :close-on-click-modal="false">
            <div class="password-form">
                <div class="form-item">
                    <div class="form-label">手机号</div>
                    <el-input v-model="passwordForm.phoneNumber" disabled></el-input>
                </div>
                <div class="form-item">
                    <div class="form-label">验证码</div>
                    <div class="verify-code-input">
                        <el-input v-model="passwordForm.code" placeholder="请输入验证码"></el-input>
                        <el-button 
                            type="primary" 
                            :disabled="countdown > 0"
                            @click="sendVerifyCode"
                            class="send-code-btn">
                            {{ countdown > 0 ? `${countdown}秒后重试` : '获取验证码' }}
                        </el-button>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">新密码</div>
                    <el-input type="password" v-model="passwordForm.newPassword" placeholder="请输入新密码"></el-input>
                </div>
                <div class="form-item">
                    <div class="form-label">确认密码</div>
                    <el-input type="password" v-model="passwordForm.confirmPassword" placeholder="请再次输入新密码"></el-input>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="passwordDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="changePassword">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import { checkTokenExpiration, clearLoginInfo } from '@/utils/auth'

    export default {
        data() {
            return {
                SetData: {
                    nickname: "",
                    gender: 1,
                    phonenumber: "",
                    email: "",
                    hospitalName: "",
                },
                passwordDialogVisible: false,
                passwordForm: {
                    phoneNumber: "",
                    code: "",
                    newPassword: "",
                    confirmPassword: ""
                },
                countdown: 0,
                isMobile: false
            }
        },
        created() {
            this.getUserInfo();
            this.checkDevice();
            window.addEventListener('resize', this.checkDevice);
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.checkDevice);
        },
        methods: {
            checkDevice() {
                this.isMobile = window.innerWidth <= 768;
            },
            checkLoginStatus() {
                const status = checkTokenExpiration();
                if (status.expired) {
                    clearLoginInfo(); // 清除登录信息
                    this.$confirm(status.message, '提示', {
                        confirmButtonText: '去登录',
                        cancelButtonText: '取消',
                        type: 'warning',
                        center: true,
                        showClose: false,
                        closeOnClickModal: false,
                        closeOnPressEscape: false
                    }).then(() => {
                        this.$router.push('/');
                    }).catch(() => {
                        // 用户点击取消，也跳转到首页
                        this.$router.push('/');
                    });
                    return false;
                }
                return true;
            },
            getUserInfo() {
                if (!this.checkLoginStatus()) return;
                
                this.$get('/getInfo').then(res => {
                    if (res.data.code === 200) {
                        const user = res.data.user;
                        this.SetData = {
                            nickname: user.nickName,
                            gender: user.sex === "0" ? 1 : 2, // 转换性别格式
                            phonenumber: user.phonenumber || "",
                            email: user.email || "",
                            hospitalName: user.hospitalName || "",
                        };
                    }
                }).catch(err => {
                    console.error("登录失效，请重新登录:", err);
                    this.$message.error("登录失效，请重新登录");
                });
            },
            SetInfo() {
                if (!this.checkLoginStatus()) return;
                
                const updateData = {
                    nickName: this.SetData.nickname,
                    sex: this.SetData.gender === 1 ? "0" : "1",
                    phonenumber: this.SetData.mobile,
                    email: this.SetData.email,
                    hospitalName: this.SetData.hospitalName,
                };

                this.$post("/system/user/profile", updateData).then(res => {
                    if (res.data.code === 200) {
                        // 更新成功后重新获取用户信息
                        this.getUserInfo();
                        // 触发头部组件更新
                        this.$bus.$emit('updateUser');
                        this.$message.success("修改成功");
                    } else {
                        this.$message.error(res.data.msg || "修改失败");
                    }
                });
            },
            showChangePasswordDialog() {
                this.passwordDialogVisible = true;
                this.passwordForm = {
                    phoneNumber: this.SetData.phonenumber,
                    code: "",
                    newPassword: "",
                    confirmPassword: ""
                };
            },
            sendVerifyCode() {
                if (!this.passwordForm.phoneNumber) {
                    this.$message.warning("手机号不能为空");
                    return;
                }
                
                this.$post(`/smsSend?phoneNumber=${this.passwordForm.phoneNumber}`).then(res => {
                    if (res.data.code === 200) {
                        this.$message.success("验证码发送成功");
                        this.startCountdown();
                    } else {
                        this.$message.error(res.data.msg || "验证码发送失败");
                    }
                }).catch(err => {
                    console.error("验证码发送失败:", err);
                    this.$message.error("验证码发送失败");
                });
            },
            startCountdown() {
                this.countdown = 60;
                const timer = setInterval(() => {
                    this.countdown--;
                    if (this.countdown <= 0) {
                        clearInterval(timer);
                    }
                }, 1000);
            },
            changePassword() {
                if (!this.checkLoginStatus()) return;
                
                // 验证表单
                if (!this.passwordForm.code) {
                    this.$message.warning("请输入验证码");
                    return;
                }
                
                if (!this.passwordForm.newPassword) {
                    this.$message.warning("请输入新密码");
                    return;
                }
                
                if (this.passwordForm.newPassword !== this.passwordForm.confirmPassword) {
                    this.$message.warning("两次输入的密码不一致");
                    return;
                }
                
                // 提交修改密码请求
                this.$post("/api/v1/works/updatePwd", {
                    phoneNumber: this.passwordForm.phoneNumber,
                    code: this.passwordForm.code,
                    newPassword: this.passwordForm.newPassword
                }).then(res => {
                    if (res.data.code === 200) {
                        this.$message.success("密码修改成功，请重新登录");
                        this.passwordDialogVisible = false;
                        
                        // 清除登录信息
                        clearLoginInfo();
                        
                        // 延迟跳转到登录页面
                        setTimeout(() => {
                            this.$router.push('/');
                        }, 1500);
                    } else {
                        this.$message.error(res.data.msg || "密码修改失败");
                    }
                }).catch(err => {
                    console.error("密码修改失败:", err);
                    this.$message.error("密码修改失败");
                });
            }
        },
    }
</script>
<style scoped>
    .InfoTit{
        padding: 20px 0;
        color: #000;
        font-size: 16px;
    }
   .StepJiBen{
       margin-left: 5vw;
       width: 70%;
   }
   .StepJiBenItem{
       display: flex;
       align-items: center;
       margin-bottom: 40px;
   }
   .StepJiBenItemTit{
       width: 135px;
       text-align: right;
       margin-right: 20px;
   }
   .StepJiBenItemTit .Tit{
       font-weight: 400;
       font-size: 16px;
       color: #999;
   }
   .StepJiBenItemVal{
       flex: 1;
   }
   .StepJiBenItemVal .WidMax{
       width: 100%;
   }
   .OrderBtns{
       display: flex;
       align-items: center;
       justify-content: center;
       margin: 20px 0;
   }
   .OrderBtn{
        padding: 5px 40px;
        background: #FFFFFF;
        font-weight: 400;
        font-size: 18px;
        color: #58C1B6;
        border-radius: 30px;
        border: 2px solid #58C1B6;
        margin-right: 20px;
        cursor: pointer;
   }
   .OrderBtn.BgBlue{
       background: #58C1B6;
       color: #fff;
   }
   
   /* 密码修改表单样式 */
   .password-form {
       padding: 0 20px;
   }
   .form-item {
       margin-bottom: 20px;
   }
   .form-label {
       margin-bottom: 8px;
       font-size: 14px;
       color: #606266;
   }
   
   @media only screen and (max-width: 768px) {
       .InfoTit{
           display: none;
       }
      .StepJiBen{
          width: 100%;
          margin: 0;
      }
      .StepJiBenItem{
          flex-direction: column;
          align-items: flex-start;
          margin-bottom: 20px;
      }
      .StepJiBenItemTit{
          width: 100%;
          text-align: left;
          margin-bottom: 8px;
          margin-right: 0;
      }
      .StepJiBenItemTit .Tit{
          font-size: 16px;
      }
      .StepJiBenItemVal{
          width: 100%;
      }
      .OrderBtns {
          margin: 15px 0;
      }
      .OrderBtn {
          padding: 5px 30px;
          font-size: 16px;
      }
      
      /* 移动端弹窗样式调整 */
      .password-form {
          padding: 0 10px;
      }
      .form-item {
          margin-bottom: 15px;
      }
      .form-label {
          font-size: 14px;
      }
      :deep(.el-dialog__body) {
          padding: 10px 0;
      }
      :deep(.el-dialog__header) {
          padding: 15px;
      }
      :deep(.el-dialog__footer) {
          padding: 10px 15px;
      }
   }
   .verify-code-input {
       display: flex;
       gap: 10px;
   }
   .verify-code-input .el-input {
       flex: 1;
   }
   .send-code-btn {
       width: 120px;
       white-space: nowrap;
   }
   :deep(.send-code-btn.el-button--primary) {
       background-color: #58C1B6 !important;
       border-color: #58C1B6 !important;
   }
   :deep(.send-code-btn.el-button--primary:hover),
   :deep(.send-code-btn.el-button--primary:focus) {
       background-color: #4BA89E !important;
       border-color: #4BA89E !important;
   }
   :deep(.send-code-btn.el-button--primary:active) {
       background-color: #3E8F86 !important;
       border-color: #3E8F86 !important;
   }
   :deep(.el-button--primary) {
       background-color: #58C1B6 !important;
       border-color: #58C1B6 !important;
   }
   :deep(.el-button--primary:hover),
   :deep(.el-button--primary:focus) {
       background-color: #4BA89E !important;
       border-color: #4BA89E !important;
   }
   :deep(.el-button--primary:active) {
       background-color: #3E8F86 !important;
       border-color: #3E8F86 !important;
   }
</style>